
<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="!data" class="info">
      <span>订单号:</span>{{ id }}<br>
      <span>物流信息暂未生成，请稍后查询！</span><br>
    </div>
    <div v-if="data" class="info">
      <template v-if="data.no">
        <span>运单号：</span>{{ data.no }}<br>
      </template>
      <template v-if="data.name">
        <span>承运人：</span>{{ data.name }}<br>
      </template>
      <template v-if="data.phone">
        <span>承运人电话：</span>{{ data.phone }}<br>
      </template>
      <template v-if="data.courier || data.courierPhone">
        <span>快递员：</span>{{ data.courier }} {{ data.courierPhone }}<br>
      </template>
    </div>
    <div v-if="data" class="progress">
      <van-steps direction="vertical" :active="0" :active-color="GetColorMain()">
        <van-step v-for="(item,index) in data.list" :key="index">
          <div>{{ item.content }}</div>
          <span>   {{ formatDate(item.time,"yyyy/MM/dd hh:mm",false) }}</span>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Step, Steps } from 'vant'
import TopBar from '@/components/TopBar'
import { formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Step.name]: Step,
    [Steps.name]: Steps,
    TopBar
  },
  data() {
    return {
      titleTop: GetSysTitle(),
      title: '订单跟踪',
      backurl: '/my/index',
      id: undefined,
      data: undefined
    }
  },

  created() {
    this.id = this.$route.params.id
    this.init()
  },
  methods: {
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetColorMainLine,
    formatDate,
    init() {
      request({
        url: '/Store/getOrderExpress',
        method: 'post',
        params: { orderId: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
      })
      //
    }
  }
}
</script>
<style scoped>
.info{
    background-color: #fff;
    padding: 0.5em;
    line-height: 1.7em;
}
.progress{
   margin-top: 0.5em;
   background-color: #fff;
   padding: 0.5em;
}
.progress span{
    font-size: 0.9em;
}
</style>
